import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  ButtonToolbar,
  Checkbox,
  CheckPicker,
  DatePicker,
  FlexboxGrid,
  Form,
  SelectPicker,
} from "rsuite";

import "./ContractFilters.css";
import { updateIn } from "json-immut";
import { HelperServices } from "../../../core/services/HelperServices";
import { get } from "lodash/fp";
import { ContractListParams } from "./ContractDataTypes";
import {
  contractForObjArr,
  contractPeriodObjArr,
  contractTypeObjArr,
  dateFormatObj,
  messageTypeArr,
  paymentFrequencyObjArr,
  roleTypeArr,
  statusObjArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { StoreServices } from "../../../core/services/StoreServices";
import { isEmptyVal, isNotEmpty } from "../../../utils/helpers";

export interface PropTypesInterface {
  onSubmit: Function;
  onClear: Function;
}

export default function ContractFilters({
  onSubmit,
  onClear,
}: PropTypesInterface) {
  const { t } = useTranslation();
  const initSearchFormData = {
    company: "",
    is_last_active_contract: "",
    is_internal_ad_allowed: "",
    is_external_ad_allowed: "",
    start_date: null,
    end_date: null,
    period_nature: "current",
    bill_payment_frequency: "",
    client_contract_type: "",
    contract_for: "",
    automate_bill: "",
    agreement_number: "",
    po_number: "",
    status: "",
    smart_search: "",
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] =
    useState<ContractListParams>(initSearchFormData);
  const company = useSelector((state: any) => state.company);
  const [showFilter, setShowFilter] = useState(false);
  const handleSearchToggle = () => setShowFilter(!showFilter);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex] = date;
    setFormData({ ...frmObj });
  };

  const clearSearchDates = () => {
    formData.start_date = null;
    formData.end_date = null;
    setFormData({ ...formData });
  };

  async function init() {
    try {
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {}, [company.id]);

  function clearSearch() {
    onClear();
    clearSearchDates();
    setFormData(initSearchFormData);
  }

  const handleCheckBoxChangeFor = (
    field_name: string,
    value: any,
    checked: boolean
  ) => {
    let form = updateIn(formData, [field_name], checked ? value : "");
    setFormData(form);
  };

  return (
    <div>
      <div className="row mb-2">
        <ButtonToolbar>
          <Button onClick={handleSearchToggle}>
            {" "}
            {t("CONTRACT")} {t("ADVANCE_SEARCH")}
          </Button>
        </ButtonToolbar>
      </div>
      {showFilter && (
        <div className="content mb-3 pb-0">
          <Form
            formValue={formData}
            onChange={(data: any) => {
              let form = { ...formData, ...data };
              setFormData(form);
            }}
            layout="inline"
          >
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="po_number">
                  <Form.ControlLabel>
                    {t("PO")} {t("NUMBER")}
                  </Form.ControlLabel>
                  <Form.Control name="po_number" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="agreement_number">
                  <Form.ControlLabel>
                    {t("AGREEMENT")} {t("NUMBER")}
                  </Form.ControlLabel>
                  <Form.Control name="agreement_number" />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="client_contract_type">
                  <Form.ControlLabel>
                    {t("CONTRACT")} {t("TYPE")}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={contractTypeObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "client_contract_type",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "client_contract_type",
                        value: "",
                      });
                    }}
                    name="client_contract_type"
                    value={formData?.client_contract_type}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="start_date">
                  <Form.ControlLabel>
                    {t("START")} {t("DATE")}
                  </Form.ControlLabel>
                  <DatePicker
                    value={formData?.start_date}
                    format={dateFormatObj.calendar_d_m_y}
                    name="start_date"
                    id="start_date"
                    onChange={(e: any) => {
                      handleDateChange(e, "start_date");
                    }}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="end_date">
                  <Form.ControlLabel>
                    {t("END")} {t("DATE")}
                  </Form.ControlLabel>
                  <DatePicker
                    value={formData?.end_date}
                    format={dateFormatObj.calendar_d_m_y}
                    name="end_date"
                    id="end_date"
                    onChange={(e: any) => {
                      handleDateChange(e, "end_date");
                    }}
                  />
                </Form.Group>
              </FlexboxGrid.Item>

              <FlexboxGrid.Item>
                <Form.Group controlId="contract_for">
                  <Form.ControlLabel>
                    {t("CONTRACT")} {t("FOR")}
                  </Form.ControlLabel>
                  <CheckPicker
                    sticky
                    onChange={(e: any) => {
                      let cntFor: any = e.filter(isNotEmpty);
                      if (e.length) {
                        handleFormChanges({
                          path: "contract_for",
                          value: cntFor.toString(),
                        });
                      } else {
                        handleFormChanges({
                          path: "contract_for",
                          value: "",
                        });
                      }
                    }}
                    onClean={() => {
                      handleFormChanges({
                        path: "contract_for",
                        value: "",
                      });
                    }}
                    data={contractForObjArr}
                    value={formData?.contract_for?.split(",")}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <FlexboxGrid justify="space-between"></FlexboxGrid>
            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="automate_bill">
                  <Form.ControlLabel>
                    {t("AUTOMATED")} {t("BILL")}
                  </Form.ControlLabel>
                  <Checkbox
                    name="automate_bill"
                    value={1}
                    onChange={(value, checked) =>
                      handleCheckBoxChangeFor("automate_bill", value, checked)
                    }
                    checked={formData.automate_bill == "" ? false : true}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="is_last_active_contract">
                  <Form.ControlLabel>
                    {t("LAST")} {t("ACTIVE")} {t("CONTRACT")}
                  </Form.ControlLabel>
                  <Checkbox
                    name="is_last_active_contract"
                    value={1}
                    onChange={(value, checked) =>
                      handleCheckBoxChangeFor(
                        "is_last_active_contract",
                        value,
                        checked
                      )
                    }
                    checked={
                      formData?.is_last_active_contract == "" ? false : true
                    }
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="is_internal_ad_allowed">
                  <Form.ControlLabel>
                    {t("INTERNAL")} {t("AD")} {t("ALLOWED")}
                  </Form.ControlLabel>
                  <Checkbox
                    name="is_internal_ad_allowed"
                    value={1}
                    onChange={(value, checked) =>
                      handleCheckBoxChangeFor(
                        "is_internal_ad_allowed",
                        value,
                        checked
                      )
                    }
                    checked={
                      formData?.is_internal_ad_allowed == "" ? false : true
                    }
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>

            <FlexboxGrid justify="space-between">
              <FlexboxGrid.Item>
                <Form.Group controlId="is_external_ad_allowed">
                  <Form.ControlLabel>
                    {t("EXTERNAL")} {t("AD")} {t("ALLOWED")}
                  </Form.ControlLabel>
                  <Checkbox
                    name="is_external_ad_allowed"
                    value={1}
                    onChange={(value, checked) =>
                      handleCheckBoxChangeFor(
                        "is_external_ad_allowed",
                        value,
                        checked
                      )
                    }
                    checked={
                      formData?.is_external_ad_allowed == "" ? false : true
                    }
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="period_nature">
                  <Form.ControlLabel>{t("PERIOD")}</Form.ControlLabel>
                  <SelectPicker
                    data={contractPeriodObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({ path: "period_nature", value });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({ path: "period_nature", value: "" });
                    }}
                    name="period_nature"
                    value={formData?.period_nature}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item>
                <Form.Group controlId="bill_payment_frequency">
                  <Form.ControlLabel>
                    {t("PAYMENT")} {t("FREQUENCY")}{" "}
                  </Form.ControlLabel>
                  <SelectPicker
                    data={paymentFrequencyObjArr}
                    valueKey="value"
                    labelKey="label"
                    onSelect={(value, item) => {
                      handleFormChanges({
                        path: "bill_payment_frequency",
                        value,
                      });
                    }}
                    onClean={(e: any) => {
                      handleFormChanges({
                        path: "bill_payment_frequency",
                        value: "",
                      });
                    }}
                    name="bill_payment_frequency"
                    value={formData?.bill_payment_frequency}
                  />
                </Form.Group>
              </FlexboxGrid.Item>
            </FlexboxGrid>
            <div className="filter-btn">
              <Button onClick={() => clearSearch()}>{t("CLEAR_FILTER")}</Button>
              <Button onClick={() => onSubmit(formData)}>{t("Search")}</Button>
            </div>
          </Form>
        </div>
      )}
    </div>
  );
}
